import React from 'react'
import SidebarInf03 from '../../components/sidebar/SidebarInf03'


const Grafika = () => {
  return (
    <div id='rozwiazaniainf03'>

    <SidebarInf03></SidebarInf03>

        <div id="rozwiazanieustawienie">
          <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <h1>Grafika na egzaminie</h1>
            <hr></hr>
            <section>
              <h2>Film - Grafika na egzaminie</h2>
              <blockquote class="introduction">
                <strong>Obecnie strona...</strong>
                Ta podstrona jest obecnie w budowie, dlatego nic tu nie znajdziesz. Autor jest zbyt leniwy
                ,aby dodać nowe rzeczy... Jednak z pewnością się tu coś pojawi. Może i jutro? Kto wie.
              </blockquote>
              <iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ?si=OsYM2e03X8kYFQ74" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </section>
           
          </div>
        </div>
    </div>
  )
}


export default Grafika